module.exports = __webpack_public_path__ + "static/img/loading1.1e30c14.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading1.gif
// module id = qb90
// module chunks = 1